module.exports = __webpack_public_path__ + "img/q4-3.8309c734.png";